import { IconButton, Label, Pivot, PivotItem, CommandBarButton, 
    IPivotItemProps, IContextualMenuProps, ContextualMenu} from '@fluentui/react';
import * as React from 'react'
import { useTranslation } from 'react-i18next';
import * as Api from '../../api/src'
import '../../css/components/test.scss'
import { commonfn } from '../../common/commonfn';
import useToken from '../account/login/useToken';
import GeneralMatrix from './generalMatrix';
import ModuleMatrix from './moduleMatrix';
import { useHistory, useLocation, useParams } from "react-router-dom";
import { LeftMenuContext } from '../../context/leftMenu.context';
import ModalAddModule from './modal/modalAddModule';
import ModalVendor from './modal/modalVendor';
import ModalAddUser from './modal/modalAddUser';
interface ParamTypes {
    id: string,
    module: string
}
const MatrixItemsApi = new Api.MatrixItemsApi();
const MatrixDetail = () => {
    let { id, module } = useParams<ParamTypes>();
    let routerHistory = useHistory();
    const search = useLocation().search;
    const { state } = useLocation();
    const { userTokenInfo } = useToken();
    const [isOpenModal, SetIsOpenModal] = React.useState(false);
    const [isOpenVendorModal, SetIsOpenVendorModal] = React.useState(false);
    const [isOpenResponsiveModal, SetIsOpenResponsiveModal] = React.useState(false);
    const { setSelectedMenuItem, } = React.useContext(LeftMenuContext);
    const { t } = useTranslation();
    const [detail, SetDetail] = React.useState<Api.MatrixItemGeneral>({});
    const [tabKey, SetTabKey] = React.useState<string>("General");
    const mnProps: IContextualMenuProps = {
        /* onDismiss: ev => {
            if (ev && 'shiftKey' in ev) {
                ev.preventDefault();
            }
        }, */
        items: [
            {
                key: 'modules',
                text: t('Modules'),
                onClick: () => {
                    SetIsOpenModal(true);
                }
            },
            {
                key: 'vendors',
                text: t('Vendors'),
                onClick: () => {
                    SetIsOpenVendorModal(true);
                }
            },
            {
                key: 'responsive',
                text: t('ResponsiveStep'),
                onClick: () => {
                    SetIsOpenResponsiveModal(true);
                }
            },
        ],
        directionalHintFixed: true,
    };
    const settingsMenu = {
        className: "slider variable-width",
        dots: false,
        infinite: true,
        centerMode: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true
    };
    React.useEffect(() => {
        setSelectedMenuItem("Matrix");
        getItemData(parseInt(id));
        SetTabKey(module || "General")
        /* let item = state as any;
        console.log(item)
        if (state) {
            getItemData(((item["state"]) as Api.MatrixItemDto).MatrixItemId || id as number)
        } else {
            getItemData(id as number);
        } */
    }, [id, module]);
    const getItemData = async (Id: number) => {
        try {
            var result = await MatrixItemsApi.apiMatrixItemsMatrixItemIdGeneralGet(Id);
            if ((result as any).response) {
                if (!(result as any).response.data.Data) {
                    routerHistory.push("/matrix");
                }
            } else {
                SetDetail(result.data.Data || {});
                if (module) {

                }
            }
        } catch (err) {
            console.log(err);
        }
    }

    const _customRenderer = (
        link?: IPivotItemProps,
        defaultRenderer?: (link?: IPivotItemProps) => JSX.Element | null,
    ) => {
        if (!link || !defaultRenderer) {
            return null;
        }
        let icon = "Warning";
        switch (link.itemIcon) {
            case "OnGoing":
                icon = "CircleHalfFull";
                break;
            case "Approved":
                icon = "SkypeCircleCheck";
                break;
        }
        return (
            <div style={{ flex: '0 1 100%' }} className="display-flex">
              {/* <Icon iconName={"LocationDot"} className={"iconTab " + link.itemIcon}/> */}
              {defaultRenderer({ ...link, itemIcon: undefined }) }
            </div>
          );
    }
    function _getMenu(props: IContextualMenuProps): JSX.Element {
        return <ContextualMenu {...props} />;
    }
    return (
        <div className="test">
            <div className={"page-header flex-center flex-justify-content-between"}>
                <div className="display-flex flex-center"><IconButton iconProps={{ iconName: "ChromeBack" }} onClick={() => {
                    routerHistory.goBack();
                }} /><Label>{detail.Product?.Name}</Label>
                </div>
                <div className="display-flex flex-center">
                    {(userTokenInfo && userTokenInfo.Role !== 'Vendor' && !detail?.IsLocked) &&
                        <CommandBarButton
                            style={{ height: '30px' }}
                            iconProps={{ iconName: "Settings" }}
                            text={t("Setting")}
                            /* onClick={() => {
                                SetIsOpenModal(true);
                            }} */
                            menuProps={mnProps}
                            menuAs={_getMenu}
                        />
                    }
                </div>
            </div>
            <Pivot className="tab-header" style={{ overflow: 'hidden' }} selectedKey={tabKey} onLinkClick={(item, e) => {
                SetTabKey(item?.props.itemKey || "General")
                if (item?.props.itemKey === 'General') {
                    getItemData(parseInt(id));
                }
            }}
                overflowBehavior={'menu'}>
                <PivotItem headerText={t('General')} key={"General"} itemKey={"General"} >
                    <GeneralMatrix MatrixItem={detail} key={detail.Id} RefeshTab={() => {
                        getItemData(parseInt(id));
                    }} IsLocked={detail?.IsLocked || false}></GeneralMatrix>
                </PivotItem>
                {detail.ModuleDetails?.map(item => {
                    if (item.CanAccess) {
                        return (
                            <PivotItem headerText={item.ModuleName || ''} key={item.Id} itemKey={(item.Id || '').toString()} itemIcon={commonfn.getModuleStatus(item)} onRenderItemLink={_customRenderer}>
                                <ModuleMatrix Item={item || {}} IsLocked={detail?.IsLocked || false}></ModuleMatrix>
                            </PivotItem>
                        );
                    }
                })}
            </Pivot>
            {isOpenModal &&
                <ModalAddModule IsOpen={isOpenModal} onCloseModal={() => { SetIsOpenModal(false) }} onSaveClick={() => {
                    getItemData(parseInt(id));
                }} MatrixItemId={detail.Id || 1} ProductTypeId={detail.Product?.ProductTypeId || 1} Modules={detail.ModuleDetails || []}></ModalAddModule>
            }
            {isOpenVendorModal &&
                <ModalVendor IsOpen={isOpenVendorModal} onCloseModal={() => { SetIsOpenVendorModal(false) }} onSaveClick={() => {
                    getItemData(parseInt(id));
                }} Item={detail.Id || 1}></ModalVendor>
            }
            {isOpenResponsiveModal &&
                <ModalAddUser IsOpen={isOpenResponsiveModal} onCloseModal={() => { SetIsOpenResponsiveModal(false) }} onSaveClick={() => {
                    getItemData(parseInt(id));
                }} Item={detail.Id || 1}></ModalAddUser>
            }
        </div >
    );
}
export default MatrixDetail;
